import React from 'react';

const values = [
  { emoji: '👥', title: 'Community First', desc: 'We believe in the power of connected communities to create positive change.' },
  { emoji: '🤝', title: 'Trust & Safety', desc: 'Creating a safe, trustworthy platform where users feel comfortable connecting.' },
  { emoji: '💡', title: 'Innovation', desc: 'We continuously evolve to better serve the changing needs of communities.' },
  { emoji: '🌍', title: 'Inclusivity', desc: 'We design our platform to be accessible and welcoming to everyone.' },
  { emoji: '🔒', title: 'Privacy First', desc: 'Your data stays private and secure with end-to-end encryption and local storage.' },
  { emoji: '🆓', title: 'Always Free', desc: 'Core community features remain free forever - no hidden fees or premium barriers.' },
];

const AboutSection: React.FC = () => {
  return (
    <div>
      {/* Story + Mission */}
      <section className="px-6 py-14 bg-white">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-indigo-600 text-xs font-semibold uppercase tracking-widest mb-2">Our Story</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Built for people far from home</h2>
          </div>

          <div className="grid sm:grid-cols-2 gap-8 mb-10">
            <div>
              <h3 className="font-bold text-gray-900 mb-3 text-lg">The Problem</h3>
              <p className="text-gray-500 leading-relaxed">
                Moving abroad is exciting — but finding your footing is hard. Local events get buried in WhatsApp groups. Trusted service providers are impossible to discover. Community groups you'd love exist, but there's no way to find them.
              </p>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 mb-3 text-lg">Our Solution</h3>
              <p className="text-gray-500 leading-relaxed">
                Sahayy brings your expat community into one place — events, services, groups, marketplace, and an AI assistant that speaks your language. Feel at home, wherever you are.
              </p>
            </div>
          </div>

          {/* Quote */}
          <div className="bg-indigo-50 border border-indigo-100 rounded-2xl px-6 py-6 text-center">
            <div className="text-2xl font-serif italic text-indigo-700 mb-2">
              एकमेका सहाय्य करू अवघे धरू सुपंथ!!
            </div>
            <div className="text-xs text-gray-400 mb-3">— संत तुकाराम महाराज</div>
            <p className="text-gray-500 italic text-sm">
              "Let's all help each other and go forward in goodness"
            </p>
          </div>

          <div className="mt-10 text-center">
            <p className="text-indigo-600 text-xs font-semibold uppercase tracking-widest mb-3">Our Mission</p>
            <p className="text-gray-600 text-lg leading-relaxed max-w-2xl mx-auto">
              To make life abroad feel less foreign — by connecting people to their communities, their language, and the help they need.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="px-6 py-14 bg-indigo-50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-indigo-600 text-xs font-semibold uppercase tracking-widest mb-2">Values</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Why Choose Sahayy?</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl border border-indigo-100 px-5 py-5 shadow-sm">
                <div className="text-3xl mb-3">{value.emoji}</div>
                <h3 className="font-bold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 py-12 bg-indigo-600 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Ready to Connect?</h2>
        <p className="text-indigo-200 mb-8">Join thousands of community members already using Sahayy</p>
        <a
          href="https://chat.sahayy.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-indigo-700 font-semibold px-8 py-3.5 rounded-2xl hover:bg-indigo-50 transition-colors"
        >
          Try for Free
        </a>
      </section>
    </div>
  );
};

export default AboutSection;
